module.exports = __webpack_public_path__ + "media/offers_icons/rolnicze-blue-04973bd0.svg";